var _rect, _rect2, _path, _rect3, _rect4, _rect5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatDots(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 23.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 23.5,
    stroke: "#E7EDE8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 15.75H32C33.7949 15.75 35.25 17.2051 35.25 19V28.2832C35.25 30.0781 33.7949 31.5332 32 31.5332H22.5801C22.004 31.5333 21.4651 31.8174 21.1387 32.292L19.6416 34.4697C19.5469 34.6075 19.3463 34.6154 19.2412 34.4854L17.3838 32.1846C17.0504 31.7715 16.5466 31.5332 16.0195 31.5332C14.2199 31.5331 12.75 30.0733 12.75 28.2832V19C12.75 17.2051 14.2051 15.75 16 15.75Z",
    stroke: "#00703E",
    strokeWidth: 1.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 23.3213,
    width: 2.5,
    height: 2.5,
    rx: 1.25,
    fill: "#00703E"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 22.5,
    y: 23.3213,
    width: 2.5,
    height: 2.5,
    rx: 1.25,
    fill: "#00703E"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 23.3213,
    width: 2.5,
    height: 2.5,
    rx: 1.25,
    fill: "#00703E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatDots);
export default __webpack_public_path__ + "static/media/chat-dots.d28497fb0ab06c27f039e30dcf519215.svg";
export { ForwardRef as ReactComponent };